"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentCard = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const material_1 = require("@mui/material");
const colors_1 = require("../../../styles/colors");
const Container = styled_1.default.div `
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 2px 4px ${colors_1.$contentCardShadow};
  display: flex;
  justify-content: center;
  padding: 12px;
`;
const ContentCard = ({ items }) => {
    return ((0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, Object.assign({ container: true, columns: items === null || items === void 0 ? void 0 : items.length, gap: 3 }, { children: (items === null || items === void 0 ? void 0 : items.length) <= 8
                ? items === null || items === void 0 ? void 0 : items.map((item, index) => ((0, jsx_runtime_1.jsx)(material_1.Grid, Object.assign({ item: true }, { children: item }), index)))
                : null })) }));
};
exports.ContentCard = ContentCard;
